/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { svg, SvgType } from '@components/atoms/icons/svg'
import { View, Text } from '@components/atoms'

interface PropsType {
	title?: string
	subtitle?: string
	isGrey?: boolean
	iconSize?: number
	children?: React.ReactNode
}

export const BoxEmptyView = (props: PropsType) => {
	const warnIcon: SvgType[] = svg.filter((anIcon: SvgType) => anIcon.name === 'warn')
	const warnGrayIcon: SvgType[] = svg.filter(
		(anIcon: SvgType) => anIcon.name === 'warn-gray',
	)
	const WarnIconComponent: SvgType['icon'] = warnIcon[0]['icon']
	const WarnGrayIconComponent: SvgType['icon'] = warnGrayIcon[0]['icon']

	const isGrey: boolean = props.isGrey ?? false
	const iconSize: number = props.iconSize ?? 100

	return (
		<View css={style}>
			<View className="innerView">
				{isGrey ? (
					<WarnGrayIconComponent width={iconSize} height={iconSize} />
				) : (
					<WarnIconComponent width={iconSize} height={iconSize} />
				)}
				{props.title !== undefined ? (
					<Text className="title" category="s1" hint={isGrey ? '500' : '100'}>
						{props.title}
					</Text>
				) : null}
				{props.subtitle !== undefined ? (
					<Text category="p1" hint={isGrey ? '500' : '100'}>
						{props.subtitle}
					</Text>
				) : null}
				{props.children && <View className="emptyViewContentView">{props.children}</View>}
			</View>
		</View>
	)
}

const style = css({
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	width: '100%',
	height: '100%',

	'.innerView': {
		position: 'absolute',

		'.emptyViewContentView': {
			marginTop: '1rem',
		},
	},
})
